import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTES } from '../routePaths';

export default function ProtectedRoute({ children }) {
    // Temporarily disable protected route enforcement.
    // Restore auth checks by re-enabling the selector and Navigate guard.
    const location = useLocation();
    const isAuthenticated = true;

    if (!isAuthenticated) {
        return <Navigate to={`${ROUTES.LOGIN}${location.search}`} replace />;
    }

    return <>{children}</>;
}
